module.exports = __webpack_public_path__ + "img/py.18e46b8f.svg";